module.exports = __webpack_public_path__ + "static/img/全民营销-2.c8df1fd7.png";